import { generateKeyValue } from "./data.js";
import { SetMarketingUnitListener } from './marketing-unit-listener'

const dictionaryAPIEndpointURL = "https://mailcentreabcprod.blob.core.windows.net/dictionary/dictionary.json?sp=r&st=2022-03-17T00:04:00Z&se=2050-03-17T08:04:00Z&spr=https&sv=2020-08-04&sr=c&sig=UuJHhF0jgRrOqz00Owru7yQ0KlkxEIGhasObv5KBk68%3D"

document.addEventListener("DOMContentLoaded", function(event) { 
  SetMarketingUnitListener();
  
  let campaignOwnerDropdown = document.getElementById('campaign-owner-select');
  var campaignOwnerString = getUrlParameter("owner");
  var campaignOwners = campaignOwnerString.split("|")

  if(campaignOwners && campaignOwners[0] !== ""){
    if(campaignOwners.length == 1){
      let newOption = new Option(campaignOwners[0],campaignOwners[0]);
      newOption.selected = true;
      campaignOwnerDropdown.append(newOption);
    } else {
      let placeholderOption = new Option('-- select an option --', 'default', true, true)
      placeholderOption.disabled = true;
      placeholderOption.style.display = "none";
      campaignOwnerDropdown.append(placeholderOption);
      
      campaignOwners.forEach(function(owner) {
        let newOption = new Option(owner,owner);
        campaignOwnerDropdown.append(newOption);
      })
    }

    fetchDictionary(
      dictionaryAPIEndpointURL, 
      onDictionarySuccess,
      onDictionaryFailure
    );


  } else {
    // Hide loader and display missing query string message.
    document.getElementById("home").style.display = 'none';
    document.getElementById("msising-query-string").style.display = 'block';
  }
});

function fetchDictionary(dictionaryURL, successHandler, errorHandler) {
  console.log("Fetching dictionary")
  superagent.get(dictionaryURL).end(function(err, res) {
    if (err) {
      errorHandler();
    } else {
      var dictionary = res.body;
      successHandler(dictionary);
    }
  })
}


function onDictionaryFailure() {
  document.getElementById("home").style.display = 'none';
  document.getElementById("msising-query-string").style.display = 'block';

  console.log("Dictionary API request failed");
  document.getElementById("msising-query-string").text = "Critical failure.   External Dictionary couldn\'t be retrieved."
}

function onDictionarySuccess(dictionary) {
  var lookupMarketingUnit = generateKeyValue(
    dictionary["fields"]["mu"].fieldValues
  );
  var lookupMarketingSubUnit = generateKeyValue(
    dictionary["fields"]["msu"].fieldValues
  );
  var lookupSource = generateKeyValue(
    dictionary["fields"]["campaign_source"].fieldValues
  );
  var lookupBrand = generateKeyValue(dictionary["fields"]["bd"].fieldValues);
  var lookupMedium = generateKeyValue(
    dictionary["fields"]["campaign_medium"].fieldValues
  );

  buildForm(
    lookupMarketingUnit,
    lookupMarketingSubUnit,
    lookupSource,
    lookupBrand,
    lookupMedium,
  );
}


// the dictionary from the API has loaded
function buildForm(
  lookupMarketingUnit,
  lookupMarketingSubUnit,
  lookupSource,
  lookupBrand,
  lookupMedium,
) {
  let markeingUnitDropdown = document.getElementById('marketing-unit-select');
  let marketingSubUnitDropdown = document.getElementById('marketing-sub-unit-select');
  let sourceDropdown = document.getElementById('source-select');
  let brandServiceDropdown = document.getElementById('brand-service-select');
  let mediumDropdown = document.getElementById('medium-select');

  // TODO: Order values alphabetically.

  var values = Object.values(lookupMarketingUnit)
  var keys = Object.keys(lookupMarketingUnit);


  keys.forEach(function(key) {
    let newOption = new Option(lookupMarketingUnit[key],key);
    markeingUnitDropdown.append(newOption);
  });

  keys = Object.keys(lookupMarketingSubUnit);

  keys.forEach(function(key) {
    let newOption = new Option(lookupMarketingSubUnit[key],key);
    marketingSubUnitDropdown.append(newOption);
  });

  keys = Object.keys(lookupSource);

  keys.forEach(function(key) {
    let newOption = new Option(lookupSource[key],key);
    sourceDropdown.append(newOption);
  });

  keys = Object.keys(lookupBrand);

  keys.forEach(function(key) {
    let newOption = new Option(lookupBrand[key],key);
    brandServiceDropdown.append(newOption);
  });

  keys = Object.keys(lookupMedium);

  keys.forEach(function(key) {
    let newOption = new Option(lookupMedium[key],key);
    mediumDropdown.append(newOption);
  });

  sortSelect(markeingUnitDropdown);
  sortSelect(marketingSubUnitDropdown);
  sortSelect(sourceDropdown);
  sortSelect(brandServiceDropdown);
  sortSelect(mediumDropdown);

  // Hide loading spinner and show form.
  document.getElementById("loader").style.display = 'none';
  document.getElementById("form-container").style.display = 'block';
}

function getUrlParameter(paramter) {
  paramter = paramter.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  var regex = new RegExp('[\\?&]' + paramter + '=([^&#]*)');
  var results = regex.exec(location.search);
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

function sortSelect(selElem) {
  var tmpAry = new Array();
  for (var i=0;i<selElem.options.length;i++) {
      tmpAry[i] = new Array();
      tmpAry[i][0] = selElem.options[i].text;
      tmpAry[i][1] = selElem.options[i].value;
  }
  tmpAry.sort();
  while (selElem.options.length > 0) {
      selElem.options[0] = null;
  }
  for (var i=0;i<tmpAry.length;i++) {
      var op = new Option(tmpAry[i][0], tmpAry[i][1]);
      selElem.options[i] = op;
  }
  return;
}